import * as React from "react";
import { Switch } from "@headlessui/react";
import { cva, type VariantProps } from "class-variance-authority";

import { classNames } from "@/src/utils/classNames";

const switchVariants = cva(
  "group relative inline-flex shrink-0 h-8 w-12 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2",
  {
    variants: {
      variant: {
        primary:
          "focus:ring-sos-yellow focus:ring-offset-2 data-[checked]:bg-sos-yellow",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export type DsSwitchPropsType = {
  value: boolean;
  onChange: (value: boolean) => void;
} & VariantProps<typeof switchVariants>;

const DsSwitch: React.FC<DsSwitchPropsType> = ({
  value,
  variant,
  onChange,
  ...props
}) => (
  <Switch
    checked={value}
    onChange={onChange}
    className={classNames(switchVariants({ variant }))}>
    <span
      aria-hidden="true"
      className="pointer-events-none inline-block size-7 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-4"
    />
  </Switch>
);

DsSwitch.displayName = "DsSwitch";

export { DsSwitch };
